import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import "./assets/css/icon.css";
import "./assets/css/iconfont.css";
import "babel-polyfill";
import favicon from "./assets/img/icon-logo-1@2x.png";
import "./utils/common.js";
// import './utils/socket.js'
import echarts from "echarts";
import store from "./vuex/store";
import VueMarkdown from "vue-markdown";
Vue.component("vue-markdown", VueMarkdown);
import Vuex from "vuex";
Vue.use(Vuex);
import VueParticles from "vue-particles";
Vue.use(VueParticles);
Vue.prototype.$echarts = echarts;
// import VueQuillEditor from 'vue-quill-editor';
// import 'quill/dist/quill.core.css';
// import 'quill/dist/quill.snow.css';
// import 'quill/dist/quill.bubble.css';
// Vue.use(VueQuillEditor)

// import * as socketApi from './utils/socket.js'
// Vue.prototype.socketApi = socketApi

import http from "./utils/http.js";
import fetch from "./utils/fetch.js";
import "swiper/dist/css/swiper.min.css";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
Vue.config.productionTip = false;
Vue.use(ElementUI, {
  size: "small",
});
// axios.defaults.headers.post['Content-Type'] = 'text/plain'
Vue.prototype.$axios = axios;
Vue.prototype.$http = http;
Vue.prototype.$fetch = fetch;

// 设置浏览器标签栏图标
function setFavicon() {
  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/png";
  link.rel = "icon";
  link.href = favicon;
  document.getElementsByTagName("head")[0].appendChild(link);
}
setFavicon();

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  const role = sessionStorage.getItem("token");
  // 白名单：不需要登录就能访问的页面
  const whiteList = ["/login", "/user-agreement", "/privacy-policy"];
  if (!role && !whiteList.includes(to.path)) {
    next("/login");
  } else {
    next();
  }
});

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js